import PropTypes from "prop-types";
import { Link } from "react-router-dom";

type IProps = {
  children: any;
  to: string;
};

const RedirectLink = ({ children, to }: IProps) => {
  const path = to === "home" ? "/kanban" : to;

  return (
    <Link
      to={path}
      style={{ textDecoration: "none", color: "inherit", display: "contents" }}
    >
      {children}
    </Link>
  );
};

RedirectLink.propTypes = {
  children: PropTypes.node.isRequired,
  to: PropTypes.string.isRequired,
};

export default RedirectLink;
